import { Pagination } from '@material-ui/core';
import React from 'react';

const CustomPagination = ({ totalPages, onPageChange }) => {
  return (
    <Pagination
      count={totalPages}
      showFirstButton
      showLastButton
      onChange={onPageChange}
    />
  );
};

export default CustomPagination;
